import { Injectable, signal } from '@angular/core';
import { MatDateRangeSelectionStrategy, DateRange } from '@angular/material/datepicker';

@Injectable()
export class LivePreviewStrategy implements MatDateRangeSelectionStrategy<Date> {
  /** Emits after every selection happens (start and end) */
  readonly selectedDate = signal<DateRange<Date>>(new DateRange<Date>(null, null));

  createPreview(active: Date | null, current: DateRange<Date>): DateRange<Date> {
    return current.start && !current.end && active
      ? new DateRange(current.start, active)
      : new DateRange(active, null);
  }

  selectionFinished(date: Date | null, current: DateRange<Date>): DateRange<Date> {
    const range = this._mergeWithPreservation(date, current);

    this.selectedDate.set(range);

    return range;
  }

  reset(): void {
    this.selectedDate.set(new DateRange<Date>(null, null));
  }

  /**
   * @explanation
   * Merges the current date with the existing date range while preserving the selected date.
   * This is useful for scenarios where the user might want to adjust the start or end date
   * without losing their previous selection.
   */
  private _mergeWithPreservation(date: Date | null, current: DateRange<Date>): DateRange<Date> {
    const currentSelected = this.selectedDate();

    if (!current.start && !current.end && date) {
      return new DateRange(date, currentSelected.end);
    }

    if (current.start && !current.end && date) {
      return date < current.start ? new DateRange(date, null) : new DateRange(current.start, date);
    }

    return new DateRange(date, null);
  }
}
